import { Dropbox } from "dropbox";
import fetch from "isomorphic-fetch";

const dbx = new Dropbox({ fetch });

export const initDropbox = () => {
  dbx.setClientId(process.env.REACT_APP_DROPBOX_API_KEY);
  dbx.setClientSecret(process.env.REACT_APP_DROPBOX_API_SECRET);
};

const getDropbox = () => dbx;

export default getDropbox;
